import { CasterChemistry } from "@/pages/caster/models/CasterChemistry";
import { useTablesStyles } from "@/pages/shift-report/styles/useTablesStyles";
import { Box, Paper } from "@material-ui/core";
import { GridApi, GridReadyEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import { useTableData } from "./hooks/useTableData";

interface Props {
	rows: CasterChemistry[];
	isLoading: boolean;
}

export const MissedChemistriesTable = ({ rows, isLoading }: Props) => {
	const classes = useTablesStyles();
	const { columns } = useTableData();

	const [gridAPI, setGridAPI] = useState<GridApi | null>(null);

	const onGridReady = (params: GridReadyEvent) => {
		setGridAPI(params.api);
	};
	useEffect(() => {
		if (gridAPI) {
			if (isLoading) gridAPI.showLoadingOverlay();
			else gridAPI.hideOverlay();
		}
	}, [gridAPI, isLoading]);

	return (
		<Paper elevation={0}>
			<Box className={`${classes.smAgGridBox} `}>
				<AgGridReact
					rowSelection="single"
					suppressRowClickSelection={true}
					pagination={false}
					singleClickEdit={false}
					tooltipShowDelay={0}
					tooltipHideDelay={2000}
					rowData={rows}
					columnDefs={columns}
					domLayout="normal"
					onGridReady={onGridReady}
				/>
			</Box>
		</Paper>
	);
};
